<template lang="">
  <CCard>
    <CCardHeader class="d-flex align-items-center">
      <CIcon
        name="cil-phone"
        class="mr-2"
      />
      <strong>Campaign Settings</strong>
    </CCardHeader>

    <CCardBody>
      <CForm
        novalidate
        @submit.prevent
      >
        <CRow class="mb-3">
          <CCol
            sm="3"
            class="pr-3"
          >
            <label class="col-form-label">
              Restrict Duplicates
            </label>
          </CCol>

          <CCol sm="9">
            <CSelect
              class="mb-0 restrict-duplicates-select"
              :value.sync="restrictDuplicates"
              :options="restrictDuplicatesOptions"
              data-cy="select-restrict-duplicates"
            />
            <small class="form-text text-muted">
              If necessary you can also set the duplicate restriction setting per individual campaign so it does not inherit this account-level setting.
            </small>
          </CCol>
        </CRow>

        <CCol
          :md="{ offset: '3', size: '9' }"
          :sm="{ offset: '3', size: '9' }"
        >
          <ButtonLoading
            type="submit"
            size="sm"
            color="primary"
            :loading="isLoading"
            :disabled="!isFormEdited"
            data-cy="button-update-campaign-settings"
            @click="updateCampaignSettings"
          >
            Update
          </ButtonLoading>
        </CCol>
      </CForm>
    </CCardBody>
  </CCard>
</template>

<script>
import { mapActions } from 'vuex'

import { showSuccessMessage } from '@/notification-utils'

export default {
  name: 'BuyerCampaignSettings',

  props: {
    accountId: {
      type: String,
      required: true
    },

    campaignSettings: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      isLoading: false,
      restrictDuplicates: 'DoNotRestrict',
      initialRestrictDuplicates: 'DoNotRestrict',
      restrictDuplicatesOptions: [
        { value: 'DoNotRestrict', label: 'Do not restrict' },
        { value: 'RestrictByCategory', label: 'Restrict by category' },
        { value: 'RestrictByCampaign', label: 'Restrict by campaign' }
      ]
    }
  },

  computed: {
    isFormEdited() {
      return this.restrictDuplicates !== this.initialRestrictDuplicates
    }
  },

  watch: {
    campaignSettings: {
      immediate: true,
      handler(newValue) {
        const value = newValue?.restrictDuplicates || 'DoNotRestrict'
        this.restrictDuplicates = value
        this.initialRestrictDuplicates = value
      }
    }
  },

  methods: {
    ...mapActions('accounts', [
      'updateBuyerCampaignSettings'
    ]),

    async updateCampaignSettings() {
      this.isLoading = true

      try {
        await this.updateBuyerCampaignSettings({
          accountId: this.accountId,
          restrictDuplicates: this.restrictDuplicates
        })

        this.initialRestrictDuplicates = this.restrictDuplicates

        showSuccessMessage('Successfully updated campaign settings')
      } catch (error) {
        //
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.restrict-duplicates-select {
  max-width: 250px;
}
</style>
